import { t } from "@/lib/i18n";
import { quickExit } from "@/hooks/useQuickExit";

export const CrisisBar = () => (
  <div className="bg-ink-900 text-cream-50" data-testid="crisis-bar" role="region" aria-label="Crisis help">
    <div className="mx-auto flex max-w-6xl items-center justify-between gap-3 px-4 py-1.5 sm:px-6">
      <p className="text-sm leading-snug sm:text-base">
        <span className="hidden sm:inline">{t("crisis.line")} </span>
        <span className="sm:hidden">In crisis? </span>
        <a href="tel:988" className="tap px-1 font-semibold underline underline-offset-4" data-testid="crisis-call-988">{t("crisis.call988")}</a>
        <span aria-hidden="true"> · </span>
        <a href="sms:988" className="tap px-1 font-semibold underline underline-offset-4" data-testid="crisis-text-988">{t("crisis.text988")}</a>
        <span aria-hidden="true"> · </span>
        <a href="tel:911" className="tap px-1 font-semibold underline underline-offset-4" data-testid="crisis-call-911">{t("crisis.call911")}</a>
      </p>
      <button
        type="button"
        onClick={quickExit}
        title={t("crisis.quickExitHint")}
        className="tap shrink-0 rounded border border-cream-50/80 px-3 text-sm font-semibold text-cream-50 hover:bg-cream-50 hover:text-ink-900 transition-colors"
        data-testid="quick-exit-button"
      >
        {t("crisis.quickExit")}
      </button>
    </div>
  </div>
);
